module.exports = "<div class=\"bg\"></div>\n<div class=\"content user\" ui-view></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/user/user.html
// module id = 746
// module chunks = 3